<module-container>
  <div *ngIf="displayModelDocumentId || displayModelPriority" class="global-shade-container"></div>
  <div class="title-container">
    <h2>Document Status</h2>
  </div>
  <abcis-table [configuration]="tableConfig" (linkClick)="onLinkClick($event)"></abcis-table>
</module-container>

<p-dialog
  [header]="'Document ' + documentNumberEvent + ' History'"
  [(visible)]="displayModelDocumentId"
>
  <document-history [documentID]="documentNumberEvent"></document-history>
</p-dialog>

<p-dialog header="View Document" [(visible)]="displayModelFileView" [style]="{ width: '50vw' }">
  <div class="view-document-container">
    <pdf-viewer [uuid]="fileViewValue"></pdf-viewer>
  </div>
</p-dialog>

<p-dialog header="Priority Change" [(visible)]="displayModelPriority">
  <form [formGroup]="priorityForm" (ngSubmit)="prioritySubmit()">
    <div class="priority-form-container">
      <input formControlName="priority" pInputText />
      <form-button
        [formButton]="priorityButton"
        type="submit"
        [isDisabled]="!priorityForm.valid"
      ></form-button>
    </div>
  </form>
</p-dialog>
